// @flow

import { Fqdn, Text } from '@gandi/ui';

import type { ExtendedSuggestion } from 'src/DomainCreate/types';
import { divideTldFromBaseDomain } from 'src/modules/domain';

import BadgeList from './BadgeList';
import CorporatePopOver from './CorporatePopOver';
import RestrictionPopOver from './RestrictionPopOver';

import styles from './FqdnCell.scss';

type Props = {
  cheapRenew?: boolean,
  isValid: boolean,
  isErrorWithRestriction?: boolean,
  corporate?: ExtendedSuggestion['corporate'],
  fqdn: ExtendedSuggestion['fqdn'],
  premium: ExtendedSuggestion['premium'],
  expiresOn?: string,
};

function FQDNContainer({
  children,
  corporatePopover,
}: {
  children: React.Node,
  corporatePopover: React.Node | null,
}) {
  if (corporatePopover)
    return (
      <Text weight="semibold" className={styles.fqdn}>
        <span>{children}</span>
        {corporatePopover}
      </Text>
    );
  return <Text weight="semibold">{children}</Text>;
}

export function FqdnCell({
  cheapRenew,
  isValid,
  isErrorWithRestriction = false,
  corporate = false,
  premium,
  fqdn,
  expiresOn,
}: Props): React.MixedElement {
  const corporatePopover =
    isValid && corporate ? (
      <CorporatePopOver id={`${fqdn}-corporate-popover`} />
    ) : null;

  const { baseFqdn, tld } = divideTldFromBaseDomain(fqdn);

  return (
    <span className={styles.fqdnContainer}>
      <FQDNContainer corporatePopover={corporatePopover}>
        <Fqdn maxLength={42} className={styles.textBreak}>
          {baseFqdn}
        </Fqdn>
        {tld && <Text className={styles.tld}>.{tld}</Text>}
      </FQDNContainer>

      {(isValid || isErrorWithRestriction) && (
        <RestrictionPopOver fqdn={fqdn} />
      )}
      <BadgeList
        cheapRenew={cheapRenew}
        premium={premium}
        fqdn={fqdn}
        expiresOn={expiresOn}
      />
    </span>
  );
}
